import React from 'react';
import { Link } from 'react-router-dom';
import { LogoIcon } from '@components/Icons';
import styles from './Footer.module.css';

interface FooterColumn {
  title: string;
  links: Array<{
    label: string;
    to: string;
  }>;
}

const footerColumns: FooterColumn[] = [
  {
    title: 'Product',
    links: [
      { label: 'Features', to: '/product' },
      { label: 'Integrations', to: '/product#integrations' },
      { label: 'Live Map', to: '/product#map' },
      { label: 'AI Assistant', to: '/product#assistant' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Team', to: '/resources#team' },
      { label: 'Documentation', to: '/resources#docs' },
      { label: 'Security', to: '/resources#security' },
      { label: 'Integration Guide', to: '/resources#integrations' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Contact', to: '/contact' },
      { label: 'Sales', to: '/contact#sales' },
      { label: 'Support', to: '/contact#support' },
    ],
  },
];

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.brand}>
          <div className={styles.logo}>
            <div className={styles.logoIcon}>
              <LogoIcon />
            </div>
            Laminar Labs
          </div>
          <p>AI-enhanced tooling for the teams that keep industry running. Built in Houston, TX.</p>
        </div>

        {footerColumns.map((column) => (
          <div key={column.title} className={styles.column}>
            <h4>{column.title}</h4>
            {column.links.map((link) => (
              <Link key={link.to} to={link.to}>
                {link.label}
              </Link>
            ))}
          </div>
        ))}
      </div>

      <div className={styles.bottom}>
        <div className={styles.copyright}>
          © {new Date().getFullYear()} Laminar Labs, Inc. All rights reserved.
        </div>
        <div className={styles.links}>
          <a href="#">Privacy</a>
          <a href="#">Terms</a>
          <Link to="/resources#security">Security</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
